module.exports = __webpack_public_path__ + "img/hero-banner.8e7a187a.png";